// ABOUTME: Screen 5D Compass: the v28 summary of the crossing's stored readings, with Done, Open the Log and Run another route on the plate.
// ABOUTME: Entering 5D completes the crossing on the server; the exits are definition actions the plate draws, so this sends nothing.

import { useCrossingContent } from '../../../hooks/useCrossingContent';
import type { ScreenProps, ScreenResult } from '../runner/screenContract';
import { buildSummary } from './summary/summaryModel';
import { SummaryScene } from './summary/SummaryScene';

export default function Screen5D({ crossing }: ScreenProps): ScreenResult {
  const { data: content } = useCrossingContent();
  const summary = content ? buildSummary(crossing, content) : null;

  return {
    layer: summary ? <SummaryScene summary={summary} /> : null,
    sceneSky: 'summary',
    headline: 'We read what happened. We mended what was reached. We found what may help next time.',
  };
}
